import React from 'react';
import { connect } from 'react-redux';

import BecomeApartnerComponent from '../components/app/BecomeApartner/BecomeApartner';

import * as actions from '../actions/become-partner';

const BecomeApartner = (props) => {
  return (
    <BecomeApartnerComponent {...props} />
  );
};

export default connect(({ becomePartner }) => becomePartner, actions)(BecomeApartner);
